window.SubscriptionFunnel.StepUpsell = {
  initializeUpsellOptions() {
    // Show/hide double deluxe option based on assortment selection
    const doubleDeluxeOption = document.getElementById('double-deluxe-option');

    if (doubleDeluxeOption) {
      if (quizData.assortment === 'toysOnly') {
        doubleDeluxeOption.style.display = 'none';
      } else {
        doubleDeluxeOption.style.display = '';
      }
    }
  },

  skipUpsellStep() {
    // Clear any upsell selection from quizData
    quizData.upsellOption = null;
    quizData.extraToy = '';
    quizData.doubleDeluxe = '';
    quizData.planTier = 'love';

    this.sendUpsellSelectionEvent(null);
    SubscriptionFunnel.FunnelNavigation.nextStep(true);
  },

  handleUpsellSelection(e) {
    const selectedOption = document.querySelector(
      `#select-upsell .upsell-radio:checked`
    );

    this.sendUpsellSelectionEvent(selectedOption);
    SubscriptionFunnel.FunnelNavigation.nextStep();
  },

  sendUpsellSelectionEvent(selectedOption) {
    const subscriberType = window.subscriberType;
    
    let params = {
      "Selected Upsell Option": selectedOption?.value || "none",
      "Upsell Step Skipped": !selectedOption,
      brand: SubscriptionFunnel.FunnelUtilities.subscription_type,
      promo: SubscriptionFunnel.FunnelUtilities.promo_type,
      "Play Subscription Collection Name":
        SubscriptionFunnel.FunnelUtilities.collection_name,
      subscriberType,
    };

    Shopify.analytics.publish("rudderstack_track", {
      eventName: "Upsell Option Selected",
      eventData: params
    });
  },
};
